import React from 'react'

import { contentType } from './ContentType.module.scss'

const ContentType = ({ 
  value 
}) => (
  <div className={ contentType }>
    <label>Content-Type</label>
    <span>{ value }</span>
  </div>
)

export default ContentType
